import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types';
import { initialState } from '.';

const selectSlice = (state: RootState) => state.price || initialState;

export const selectPrice = createSelector(
  [selectSlice],
  state => state.data.items,
);
export const selectPriceResponse = createSelector(
  [selectSlice],
  state => state,
);
